import { Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { provideBusyStateStream } from '../loading-state/busy-state.provider';
import { HttpBusyStateInterceptor } from './http-busy-state.interceptor';

export const httpBusyStateProvider = provideBusyStateStream({
    deps: [HttpBusyStateInterceptor],
    useFactory: (httpInterceptor: HttpBusyStateInterceptor) => httpInterceptor.busy$
});

export const httpBusyStateProviders: Provider[] = [
    httpBusyStateProvider,
    /**
     * To allow injection of the interceptor, it is "providedIn: 'root'". To make Angular use the same instance of the interceptor
     * and not create a second one, I used `useExisting`. This will fetch the existing instance already created by Angular when
     * the service was instantiated at root level.
     */
    { provide: HTTP_INTERCEPTORS, useExisting: HttpBusyStateInterceptor, multi: true }
];
